import { DisplayMode } from "./DisplayMode";

/**
 * Gets the display mode for a specified width.
 * @param width The width to get the display mode for.
 * @returns The display mode associated with the specified width.
 */
export function getDisplayModeForWidth(width: number): DisplayMode {
  if (width < 768) return "mobile";
  else if (width < 1200) return "tablet";
  else if (width < 1400) return "smallDesktop";
  else return "desktop";
}
